import Component from '../inherited/Component';

export default class Marquee extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    this._windowWidth = window.innerWidth;
  }

  async mount() {
    let { default: SuperMarquee } = await import('sp-supermarquee');
    this._marquee = new SuperMarquee(this._elem, this._options);
  }
}
